module.exports = __webpack_public_path__ + "img/pie-bg1.0836c659.png";